import { render, staticRenderFns } from "./ProductDoubleEach.vue?vue&type=template&id=45359fac&scoped=true&"
import script from "./ProductDoubleEach.vue?vue&type=script&lang=js&"
export * from "./ProductDoubleEach.vue?vue&type=script&lang=js&"
import style0 from "./ProductDoubleEach.vue?vue&type=style&index=0&id=45359fac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45359fac",
  null
  
)

export default component.exports